import React, { useEffect, useId, useRef, useState } from 'react';
import './FilterSelect.css';

const FilterSelect = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  placeholder = 'Select…',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const listId = useId();

  const selected = options.find((opt) => opt.value === value);
  const displayLabel = selected?.label || placeholder;

  useEffect(() => {
    if (!open) return undefined;

    const handlePointer = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handlePointer);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handlePointer);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);

  const handleSelect = (optValue) => {
    onChange(optValue);
    setOpen(false);
  };

  return (
    <div
      className={`filter-select-field ${disabled ? 'is-disabled' : ''} ${open ? 'is-open' : ''}`}
      ref={rootRef}
    >
      {label && <span className="filter-select-label">{label}</span>}
      <div className="filter-select-control">
        <button
          type="button"
          className="filter-select-trigger"
          disabled={disabled}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-controls={listId}
          onClick={() => !disabled && setOpen((v) => !v)}
        >
          <span className="filter-select-value">{displayLabel}</span>
          <i className={`bi bi-chevron-down filter-select-chevron ${open ? 'is-up' : ''}`} aria-hidden />
        </button>
        {open && !disabled && (
          <ul id={listId} className="filter-select-menu" role="listbox" aria-label={label}>
            {options.map((opt) => (
              <li key={opt.value} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={opt.value === value}
                  className={`filter-select-option ${opt.value === value ? 'is-selected' : ''}`}
                  onClick={() => handleSelect(opt.value)}
                >
                  <span>{opt.label}</span>
                  {opt.value === value && <i className="bi bi-check2" aria-hidden />}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FilterSelect;
